import React from 'react';
import { useCookies } from 'react-cookie';
import styled from 'styled-components/macro';
import { useSelector } from 'src/client/redux';
import { isPartner } from '../../utils/affiliateTracking';
import { usePromotions } from 'src/client/helpers/usePromotions';
import { PromoBanner } from 'src/client/containers/Promo/PromoBanner';
import { PlayboyBannerImage } from 'src/client/containers/Updates/PlayboyBannerImage';
import { usePlayboyLandingPage } from 'src/client/helpers/usePlayboyLandingPage';
import { MAM_COOKIE_NAME } from 'src/shared/constants/cookies';
import { UpdatesSlider } from 'src/client/containers/Updates/UpdatesSlider/UpdatesSlider';
import { useShowSfwSite } from 'src/client/helpers/useFeatureFlags';

const StyleWrapper = styled.div`
  .splash-tablet ins > a > img,
  .splash-mobile ins > a > img {
    width: 100%;
    height: auto;
  }
`;

export const UpdatesBanner = () => {
  const { user } = useSelector((state) => state.auth);
  const { loadingBanners } = useSelector((state) => state.updates);
  const [cookies] = useCookies([MAM_COOKIE_NAME]);
  const { isPromoBannerActive } = usePromotions();
  const { config } = useSelector((state) => state.app);
  const isPlayboyLandingPage = usePlayboyLandingPage();
  const showSfwSite = useShowSfwSite();

  const { splash, components } = config;

  const hasSplashPage = splash?.active;

  const showPlayboyBanner = !user?.validSubscription && isPlayboyLandingPage;

  const showPromoBanner =
    isPromoBannerActive &&
    !showPlayboyBanner &&
    !user?.validSubscription &&
    !hasSplashPage &&
    !isPartner(cookies[MAM_COOKIE_NAME], config.partnerIDs);

  const showUpdateSlider =
    !showSfwSite && components.updatesSlider?.component && !loadingBanners && !showPlayboyBanner && !showPromoBanner;

  const showAnyBanner = showPromoBanner || showPlayboyBanner || showUpdateSlider;

  if (!showAnyBanner) return null;

  return (
    <StyleWrapper>
      {showPromoBanner && <PromoBanner />}
      {showPlayboyBanner && components.updatesSlider?.component && (
        <PlayboyBannerImage campaign="playboy-updates-banner" />
      )}
      {showUpdateSlider && <UpdatesSlider className="updates-slider" {...(components.updatesSlider.props || {})} />}
    </StyleWrapper>
  );
};
